import Portfolio from './Portfolio';
const __Portfolio = Portfolio;
export { __Portfolio as Portfolio };
export default Portfolio;